



































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import moment, { Moment } from 'moment';
import { namespace } from 'vuex-class';
const User = namespace('user');
const Common = namespace('common');

@Component({
  components: {},
})
export default class InboundPlanPage extends Vue {
  @Common.State('biz_list')
  protected bizList!: TypeStoreCommon.BizConfig;
  /** 更新当月备货计划状态 */
  @User.Action('setInboundPlanData') protected setInboundPlanData!: () => void;
  /** 总数 */
  private total: number | null = 0;
  /** 表格配置参数 */
  private columns: TypeBase.TableColumn[] = [];
  /** 已选择数据key */
  private selectedList: string[] = [];
  /** 选择行  */
  private rowSelection: TypeBase.RowSelection = {};
  /** 查询表单 */
  private searchData: TypeInboundPlan.SearchParams = this.initSearchData();
  /** 实际查询入参 */
  private searchParam: TypeInboundPlan.SearchParams = this.initSearchData();
  /** 时间区域 */
  private datetimeDefaultValue: Moment[] = this.$util.getDefaultTimeCondition();
  /** 备货计划列表数据 */
  private data: TypeInboundPlan.ListDataItem[] = [];
  /** 区域仓 */
  private warehouseList: TypeCommon.AllWarehouseListItem[] = [];
  /** 列表加载状态 */
  private loadingStatus: boolean = false;
  /** 备货计划状态 */
  @enumData('StockPlan/PlanListStatusEnum')
  private planListStatusEnum: TypeBase.EnumListItem[] = [];
  /** 时间范围枚举 */
  @enumData('StockPlan/PlanListTimeTypeEnum')
  private planListTimeTypeEnum: TypeBase.EnumListItem[] = [];
  /**
   * 重新请求列表数据
   */
  public updateSearchList(): void {
    this.queryList(this.searchData);
  }
  /**
   * 监听日期变化
   */
  @Watch('datetimeDefaultValue', { immediate: true })
  private onDatetimeDefaultValueChange(arr: Moment[]): void {
    if (arr.length) {
      this.searchData.start_time = this.$util.formatDateTime(arr[0], 'YYYY-MM');
      this.searchData.end_time = this.$util.formatDateTime(arr[1], 'YYYY-MM');
    } else {
      this.searchData.start_time = '';
      this.searchData.end_time = '';
    }
  }
  /**
   * 设置columns
   */
  private setColumns(): void {
    /** 填写年月和状态合并列设置 */
    const filloInMonthCustomRender = (text: string, row: TypeInboundPlan.ListDataItem, index: number): TypeInboundPlan.RenderObj => {
      return {
        children: text || '--',
        attrs: { rowSpan: row.filloInMonthRowSpan ? row.filloInMonthRowSpanLength : 0 },
      };
    };
    /** 发货年月合并列设置 */
    const shipmentsMonthCustomRender = (text: string, row: TypeInboundPlan.ListDataItem, index: number): TypeInboundPlan.RenderObj => {
      return {
        children: row.shipmentsMonthRowSpanMarkDanger ? <span class='danger'>{`${text}` || '--'}</span> : <span>{`${text}` || '--'}</span>,
        attrs: { rowSpan: row.shipmentsMonthRowSpan ? row.shipmentsMonthRowSpanLength : 0 },
      };
    };
    const h = this.$createElement;
    /** 操作合并列设置 */
    const operationCustomRender = (text: string, row: TypeInboundPlan.ListDataItem, index: number): TypeInboundPlan.RenderObj => {
      /** 当月的计划才可以编辑、提交、删除 */
      const date = moment(new Date()).format('YYYY-MM');
      return {
        children: (
          <my-operation slot='operation' class='operation-btns' slot-scope={row}>
            {row.month_period === date && row.status !== this.$enum.warehouse.PlanListStatusEnum.SUBMIT ? (
              <a-button
              size='small'
              data-sign='inbound_plan_list_item_edit'
              type='link'
              class='small-btn'
              disabled={!this.isEditInboundPlan(new Date(row.month_period))}
               v-permission='inbound_plan_edit'
               onClick={() => this.handleEdit(row)}>
                {this.t('编辑')}
              </a-button>
            ) : (
              ''
            )}
            {row.month_period === date && row.status === this.$enum.warehouse.PlanListStatusEnum.DRAFT ? (
              <a-button
              class='small-btn'
              size='small'
              data-sign='inbound_plan_list_item_submit'
              type='link'
              disabled={!this.isEditInboundPlan(new Date(row.month_period))}
              v-permission='inbound_plan_submit'
              onClick={() => this.handleSubmit(row)}>
                {this.t('提交')}
              </a-button>
            ) : (
              ''
            )}
            {row.status === this.$enum.warehouse.PlanListStatusEnum.DRAFT ? (
              <a class='mr-10' v-permission='inbound_plan_disabled' data-sign='inbound_plan_list_item_disabled' onClick={() => this.handleDisabled(row)}>
                {this.t('删除')}
              </a>
            ) : (
              ''
            )}
            {row.status === this.$enum.warehouse.PlanListStatusEnum.SUBMIT ? (
              <span>
                <a-button
                  type='link'
                  class='small-btn'
                  data-sign='inbound_plan_list_item_modify'
                  disabled={!this.isEditInboundPlan(new Date(row.month_period))}
                  onClick={() => this.handleEdit(row)}
                >
                  {this.t('修改')}
                </a-button>
                <a data-sign='inbound_plan_list_item_export' class='mr-10' onClick={() => this.handleExportMonth(row)}>
                  {this.t('导出')}
                </a>
              </span>
            ) : (
              ''
            )}
          </my-operation>
        ),
        attrs: { rowSpan: row.filloInMonthRowSpan ? row.filloInMonthRowSpanLength : 0 },
      };
    };
    this.columns = [
      {
        title: this.t('填写年月'),
        dataIndex: 'month_period',
        filterEmpty: true,
        customRender: filloInMonthCustomRender as any,
      },
      {
        title: this.t('发货年月'),
        dataIndex: 'deliver_time',
        filterEmpty: true,
        customRender: shipmentsMonthCustomRender as any,
      },
      {
        title: this.t('区域仓'),
        dataIndex: 'warehouse_code',
        width: 200,
        scopedSlots: { customRender: 'warehouse_code' },
      },
      {
        title: this.t('发货体积（m³）'),
        dataIndex: 'deliver_volume',
        align: 'right',
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('备注'),
        dataIndex: 'remark',
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('状态'),
        dataIndex: 'status_text',
        filterEmpty: true,
        customRender: filloInMonthCustomRender as any,
      },
      {
        title: this.t('操作'),
        dataIndex: 'operation',
        width: 200,
        fixed: 'right',
        customRender: operationCustomRender as any,
      },
    ];
  }
  /**
   * 初始化参数
   */
  @userPrefPageSize('InboundPlanPage')
  private initSearchData(): TypeInboundPlan.SearchParams {
    return {
      /** 单据状态 （1:草稿，2：已提交，全部：不传或者传null） */
      status: undefined,
      /** 仓库代码 */
      warehouse_code: undefined,
      /** 时间类型  */
      date_type: this.$enum.warehouse.PlanListTimeTypeEnum.MONTH_PERIOD,
      /** 开始时间  */
      start_time: '',
      /** 结束时间  */
      end_time: '',
      /** 月标签(不传表示全部)，0：上半月，1：下半月 */
      month_tag: undefined,
      /** 页码 */
      page_index: 1,
      /** 每页显示数量 */
      page_size: 20,
    };
  }
  /**
   * 请求备货计划列表
   */
  @loading('loadingStatus')
  private async queryList(params: TypeInboundPlan.SearchParams): Promise<void> {
    this.searchParam = this.$util.deepCopy(params);
    this.total = null;
    const res = await this.$api.inboundPlan.queryStockPlanList<TypeBase.ListResult<TypeInboundPlan.ListDataItem[]>>(params);
    if (res.code === 0) {
      const data = res.data.list || [];
      this.total = res.data.total;
      this.data = this.setDataRowSpan(data);
    }
  }
  /** 获取列表数据 */
  private getList() {
    this.rowSelection.selectedRowKeys = this.selectedList = [];
    this.queryList(this.searchData);
  }
  /**
   * 是否可以修改备货计划
   */
  private isEditInboundPlan(date: Date): boolean {
    const day = this.bizList.stock_plan_submit_data_stop_edit_day;
    const nowDate = new Date();
    return !!day && date.getMonth() === nowDate.getMonth() && date.getFullYear() === nowDate.getFullYear() && nowDate.getDate() <= day;
  }
  /**
   * 合并列数据
   */
  private setDataRowSpan(data: TypeInboundPlan.ListDataItem[]) {
    let filloInMonthSameIndexs: number[] = [];
    let shipmentsMonthSameIndexs: number[] = [];
    data.forEach((item, index) => {
      const lastItem = data[index + 1];
      if (lastItem) {
        /** 填写年月是否相同，相同的合并列 */
        const filloInMonthIisSame = item.month_period === lastItem.month_period;
        if (!filloInMonthIisSame) {
          this.calRowSpan(data, filloInMonthSameIndexs, item, 'filloInMonthRowSpan');
          filloInMonthSameIndexs = [];
        } else {
          filloInMonthSameIndexs.push(index);
        }
        /** 填写年月+发货年月是否相同，相同的合并列 */
        const shipmentsMonthIisSame = filloInMonthIisSame && item.deliver_time + item.deliver_month_tag === lastItem.deliver_time + lastItem.deliver_month_tag;
        if (!shipmentsMonthIisSame) {
          this.calRowSpan(data, shipmentsMonthSameIndexs, item, 'shipmentsMonthRowSpan', true);
          shipmentsMonthSameIndexs = [];
        } else {
          shipmentsMonthSameIndexs.push(index);
        }
      } else {
        this.calRowSpan(data, filloInMonthSameIndexs, item, 'filloInMonthRowSpan');
        this.calRowSpan(data, shipmentsMonthSameIndexs, item, 'shipmentsMonthRowSpan', true);
      }
    });
    return data;
  }
  /**
   * 计算合并数据
   */
  private calRowSpan(data: any[], indexs: number[], item: any, key: string, isMark?: boolean) {
    if (indexs.length) {
      data[indexs[0]][key] = true;
      data[indexs[0]][key + 'Length'] = indexs.length + 1;
      if (isMark && item.mark_danger) {
        data[indexs[0]][key + 'MarkDanger'] = true;
      }
    } else {
      item[key] = true;
      item[key + 'Length'] = 1;
      if (isMark && item.mark_danger) {
        item[key + 'MarkDanger'] = true;
      }
    }
  }
  /**
   * 获取仓库列表
   */
  private async queryWarehouseList(): Promise<void> {
    const res = await this.$api.common.queryAllWarehouseList();
    if (res.code === 0) {
      this.warehouseList = res.data;
    }
  }
  /**
   * 单据状态变化
   */
  private handleChangeStatus(): void {
    this.searchData.page_index = 1;
    this.getList();
  }
  /**
   * 搜索
   */
  private handleSearch(): void {
    console.log(this.searchData);
    this.searchData.page_index = 1;
    this.getList();
  }
  /**
   * 重置
   */
  private async handleClear(): Promise<void> {
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.searchData = this.initSearchData();
    this.$nextTick(() => {
      this.getList();
    });
  }
  /**
   * 请求导出接口
   */
  private async export(params: TypeInboundPlan.ExportParams): Promise<void> {
    const res = await this.$api.inboundPlan.stockPlanExport(params);
    if (res.code === 0) {
      this.$util.exportExcel(res.data);
    }
  }
  /**
   * 导出全部
   */
  private handleExportAll(): void {
    const params = this.$util.deepCopy(this.searchParam);
    delete params.page_index;
    delete params.page_size;
    this.export(params);
  }
  /**
   * 导出已选
   */
  private handleExportSelected(): void {
    if (!this.selectedList.length) {
      this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip));
    } else {
      this.export({
        ids: this.selectedList,
      });
    }
  }
  /**
   * 导出填写年月当月数据
   */
  private handleExportMonth(row: TypeInboundPlan.ListDataItem): void {
    this.export({
      export_code: row.code,
    });
  }
  /**
   * 分页
   */
  private handlePageChange(page: number, pageSize: number): void {
    this.searchData.page_index = page;
    this.searchData.page_size = pageSize;
    this.getList();
  }
  /**
   * 删除
   */
  private handleDisabled(record: TypeInboundPlan.ListDataItem): void {
    const modal = this.$confirm({
      title: this.tc('温馨提示'),
      content: this.t('请确认是否删除？'),
      onOk: async () => {
        try {
          await this.$api.inboundPlan.stockPlanDelete({ code: record.code });
          this.getList();
          const date = moment(new Date()).format('YYYY-MM');
          if (record.month_period === date) {
            this.setInboundPlanData();
          }
        } catch (error) {
          modal.destroy();
        }
      },
    });
  }
  /**
   * 新增
   */
  private async handleAdd(): Promise<void> {
    const res = await this.$api.inboundPlan.queryStockPlanMonthPlan();
    if (!this.isEditInboundPlan(new Date())) {
      this.$message.warning(this.t('每月{0}号为提交截止日期，已逾期无法提交，请知悉！', [this.bizList.stock_plan_submit_data_stop_edit_day]));
      return;
    }
    if (res.data.status === null) {
      this.$message.warning(this.t('当月无需填写备货计划。'));
      return;
    }
    if ((res.data.status as number) === this.$enum.warehouse.PlanListStatusEnum.DRAFT) {
      this.$message.warning(this.t('当月已存在草稿备货计划，请完善草稿并提交。'));
      return;
    }
    if ((res.data.status as number) === this.$enum.warehouse.PlanListStatusEnum.SUBMIT) {
      this.$message.warning(this.t('当月已填写，不能继续新增；如需修改可点击“修改”按钮。'));
      return;
    }
    this.$router.push({
      name: 'InboundPlanAddPage',
      query: {
        noCache: '1',
        code: String(res.data.code),
      },
    });
  }
  /**
   * 编辑
   */
  private handleEdit(record: TypeInboundPlan.ListDataItem): void {
    this.$router.push({
      name: 'InboundPlanEditPage',
      query: {
        code: record.code,
      },
    });
  }
  /**
   * 提交
   */
  private handleSubmit(record: TypeInboundPlan.ListDataItem): void {
    const modal = this.$confirm({
      title: this.tc('温馨提示'),
      content: this.t('请确认是否提交？'),
      onOk: async () => {
        try {
          const res = await this.$api.inboundPlan.stockPlanSubmit({ code: record.code });
          /** 未填写完成 */
          if (!res.data) {
            this.gotoEidt(record);
          } else {
            this.getList();
            this.setInboundPlanData();
          }
        } catch (error) {
          modal.destroy();
        }
      },
    });
  }
  /**
   * 提示去编辑页面
   */
  private gotoEidt(record: TypeInboundPlan.ListDataItem) {
    const modal = this.$confirm({
      title: this.tc('体积未填写完整'),
      content: this.t('请前往编辑'),
      okText: this.t('编辑'),
      onOk: async () => {
        try {
          this.handleEdit(record);
        } catch (error) {
          modal.destroy();
        }
      },
    });
  }

  private created() {
    this.setColumns();
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: (selectedRowKeys: string[]) => {
        this.rowSelection.selectedRowKeys = this.selectedList = selectedRowKeys;
      },
    };
    this.queryWarehouseList();
    const status = this.$route.query.status;
    if (status) {
      this.searchData.status = Number(status);
      this.datetimeDefaultValue = this.$util.getDefaultTimeCondition(this.$util.monthToDay());
    }
    this.$nextTick(() => {
      this.getList();
    });
  }
}
